var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#667085;stroke-width:4.9766;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.8,39.5c4.3,0,7.6-3.4,7.6-7.5s-3.4-7.5-7.6-7.5s-7.6,3.4-7.6,7.5S27.7,39.5,31.8,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,29.4c0.9,1.2,1.5,1.8,1.5,2.6c0,0.8-0.5,1.5-1.5,2.6C49.2,38.9,41.3,46.8,32,46.8s-17.2-7.9-20.9-12.2 c-0.9-1.2-1.5-1.8-1.5-2.6c0-0.8,0.5-1.5,1.5-2.6c3.7-4.3,11.6-12.2,20.9-12.2C41.3,17.1,49.2,25,52.9,29.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReport);
export default __webpack_public_path__ + "static/media/view-report.308503e646168e9ae4fda9cb55fe2734.svg";
export { ForwardRef as ReactComponent };